import classes from './index.module.scss';

export interface MyTableHeaderProps {
  className?: ClassNames;
  left?: ReactNode;
  right?: ReactNode;
}

export default function MyTableHeader({ className, left, right }: MyTableHeaderProps) {
  return (
    <div className={cls(classes.myTableHeader, className)}>
      <div className={classes.left}>{left}</div>
      <div className={classes.right}>{right}</div>
    </div>
  );
}
